module.exports = __webpack_public_path__ + "1b9ee6459cf356cfb42dd0d083906381.png";